<ul *ngIf="!artist">
  <li *ngFor="let art of artists">
    <a routerLink="/songs/{{art.key}}">{{art.artist}}</a>
  </li>
</ul>

<ul *ngIf="artist">
  <li *ngFor="let song of songs">
    <a routerLink="/songs/{{artist}}/{{song.key}}">{{song.title}}</a>
  </li>
</ul>
